var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNurse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.956,
    height: 30,
    fill: "#73a91b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-870 -804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.5,0C55,0,55,0,55,27.5S55,55,27.5,55,0,55,0,27.5,0,0,27.5,0Z",
    transform: "translate(870 804)",
    fill: "#eaf2dd"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(884 817)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7,12.117A4.349,4.349,0,0,0,23.77,8.53l.649-2.552a3.393,3.393,0,0,0-1.305-3.569C21.279,1.007,17.772,0,14.079,0s-7.2,1.007-9.034,2.409A3.393,3.393,0,0,0,3.74,5.978l.618,2.43a4.411,4.411,0,0,0-2.1,3.709C2.981,28.375-.468,25.451.054,27.72c.352,1.532,4.467,1.6,10.592,1.587a8.858,8.858,0,0,0,6.867,0c6.014.011,10.041-.073,10.39-1.588.522-2.268-2.926.655-2.205-15.6M11.1,4.631H13.03V2.7h1.9V4.631h1.926v1.9H14.926V8.453h-1.9V6.527H11.1ZM22.539,17.6c-.553,5.532-4.268,9.866-8.46,9.866S6.172,23.135,5.619,17.6c-.053-.529-.082-.985-.1-1.387a19.606,19.606,0,0,0,4.744-2.564c1.72,1.247,5.614,3.388,12.3,3.674-.009.093-.015.179-.025.276",
    transform: "translate(0 0)",
    fill: "#73a91b"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNurse);
export default __webpack_public_path__ + "static/media/Nurse.8a6feaeb0a62aeaeb1f39eba5beb47a3.svg";
export { ForwardRef as ReactComponent };